/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const dateFormatsMap: { [key: string]: string } = {
  __fallback: 'yyyy/MM/dd HH:mm',
  en: 'yyyy/MM/dd HH:mm',
  de: 'dd.MM.yyyy HH:mm',
};
